export enum BlocTypes {
  H = 'H',
  S = 'S',
  D = 'D',
  P = 'P',
  C = 'C',
  I = 'I',
  V = 'V'
}
